export const CEP_MASK_MAX_LENGTH = 9;

export function sanitizeCepDigits(value: string): string {
  return value.replace(/\D/g, '').slice(0, 8);
}

export function formatCepMask(digits: string): string {
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

export function parseCepFieldValue(value: string): string {
  return formatCepMask(sanitizeCepDigits(value));
}
